/** Liste + éditeur factures — même moteur que les devis. */
import { QuotesPage, type QuoteSeed } from "./QuotesPage";

export type InvoiceSeed = QuoteSeed;

type InvoicesPageProps = {
  companyId: number;
  seed?: InvoiceSeed | null;
  onSeedUsed?: () => void;
  onOpenClient?: (clientId: number) => void;
  onOpenQuote?: (id: number) => void;
  onOpenCredit?: (id: number) => void;
  onOpenRecurring?: (fromDocumentId: number) => void;
};

export function InvoicesPage(props: InvoicesPageProps) {
  return <QuotesPage kind="invoice" {...props} />;
}
